<template lang="pug">
//- pre currentComponent: {{currentComponent}}
i.icon
  component(:is="currentComponent")

</template>

<script setup>
import { shallowRef, onMounted } from 'vue'
import _kebabCase from 'lodash/kebabCase'
import _replace   from 'lodash/replace'

// Here we are only importing the icons used in this app
import { 
  PhCaretDown,
  PhCaretRight,
  PhCaretLeft,
  PhCaretUp,
  PhCaretDoubleDown,
  PhCaretDoubleRight,
  PhCaretDoubleLeft,
  PhCaretDoubleUp,
  PhCube,
  PhFileText,
  PhGear,
  PhGearSix,
  PhHorse,
  PhHeart,
  PhListDashes,
  PhSignOut,
  PhSquaresFour,
  PhWarningDiamond,
} from "@phosphor-icons/vue";

const phosphorIcons = [
  PhCaretDown,
  PhCaretRight,
  PhCaretLeft,
  PhCaretUp,
  PhCaretDoubleDown,
  PhCaretDoubleRight,
  PhCaretDoubleLeft,
  PhCaretDoubleUp,
  PhCube,
  PhFileText,
  PhGear,
  PhGearSix,
  PhHorse,
  PhHeart,
  PhListDashes,
  PhSignOut,
  PhSquaresFour,
  PhWarningDiamond,
]

const iconMapping = phosphorIcons.map((comp) => {
  const className = comp.name
  const name = _replace(_kebabCase(comp.name), 'ph-', '')
  return {
    name: name,
    className: className,
    component: comp,
  }
})

const props = defineProps({
  name:  { type: String, required: true},
})

onMounted(() => setIcon())

let currentComponent = shallowRef()
const fallbackIcon = PhWarningDiamond

function setIcon() {
  const icon = iconMapping.find((i) => i.name == props.name)
  if (icon?.component) {
    currentComponent.value = icon?.component
  } else {
    currentComponent.value = fallbackIcon
    console.warn(`AppIcon Error: Could not find icon for '${props.name}'`)
  }
  // console.log('setIcon', props.name, currentComponent)
}

</script> 